// extracted by mini-css-extract-plugin
export default {"header-icons":"PDPModalIcons-module__header-icons__C4EeA"};